import { BaseElement, defineElement } from '@webtides/element-js';
import lozad from 'lozad';
import LazySrcEvents from './LazySrcEvents';

export default class LazySrc extends BaseElement {
    properties() {
        return {
            rootMargin: '48px',
            threshold: 0,
            imgClass: '',
            imgAlt: '',
            deferObserve: false,
        };
    }
    connected() {
        this._placeholder = this.querySelector('[slot=placeholder]');
        this.initObserver();
    }

    initObserver() {
        this._observer = lozad(this.firstElementChild, {
            rootMargin: this.rootMargin,
            threshold: this.threshold,
            loaded: target => {
                this.dispatch(LazySrcEvents.LOZAD_LOAD, this, true);

                const img = target.querySelector('img');
                if (img && this.imgClass !== '') {
                    img.setAttribute('class', this.imgClass);
                }

                if (img && this.imgAlt !== '') {
                    img.setAttribute('alt', this.imgAlt);
                }

                if (img) {
                    img.onload = () => {
                        this.dispatch(LazySrcEvents.IMG_LOAD, this, true);
                        if (this._placeholder) {
                            this.removeChild(this._placeholder);
                        }
                    };
                    img.onerror = () => {
                        this.dispatch(LazySrcEvents.IMG_ERROR, this, true);
                    };
                } else if (this._placeholder) {
                    this.removeChild(this._placeholder);
                }
            },
        });
        if (this.deferObserve === false) {
            this.observe();
        }
    }

    observe() {
        this._observer.observe();
    }
}

defineElement('lazy-src', LazySrc);
